export default "__VITE_ASSET__$b2R5Frq__"